import { css, cssManager } from '@design.estate/dees-element';
import { themeDefaultStyles } from '../../00theme.js';

export const appuiAppbarStyles = [
    themeDefaultStyles,
    cssManager.defaultStyles,
    css`
      :host {
        --appbar-height: var(--dees-appui-row-height);
        --appbar-font-size: var(--dees-font-control-size);
        --appbar-fg-strong: var(--dees-color-text-primary);
        --appbar-fg: var(--dees-color-text-secondary);
        --appbar-fg-faint: var(--dees-color-text-muted);
        --appbar-wash-strong: var(--dees-color-fill-secondary);
        --appbar-separator: var(--dees-color-border-subtle);
        --appbar-control-border: var(--dees-color-border-subtle);
        
        display: block;
        position: relative;
        width: 100%;
        height: var(--appbar-height);
        border-bottom: 1px solid var(--appbar-separator);
        background: var(--dees-appui-chrome-bg);
        color: var(--appbar-fg);
        font-size: var(--appbar-font-size);
        font-weight: 500;
        line-height: 1;
        letter-spacing: var(--dees-font-caption1-tracking);
        display: grid;
        grid-template-columns: minmax(0, auto) minmax(0, 1fr) auto;
        container-type: inline-size;
        -webkit-app-region: drag;
        user-select: none;
      }

      .menus {
        display: flex;
        align-items: center;
        min-width: 0;
        height: 100%;
        gap: 2px;
        padding: 0 8px;
        cursor: default;
        overflow: hidden;
      }

      button { font: inherit; color: inherit; background: transparent; border: 0; margin: 0; }
      .full-menus { display: flex; align-items: center; gap: 2px; min-width: 0; }
      .compact-menus { display: none; }
      button:focus-visible { outline: 2px solid var(--dees-color-focus-ring); outline-offset: -2px; }
      button.search-icon { display: grid; place-items: center; width: 28px; height: 28px; padding: 0; border-radius: var(--dees-radius-md); }
      @media (pointer: coarse) {
        button.search-icon, button.user-info, button.activity-toggle, .menuItem { min-width: 44px; min-height: 44px; }
      }

      .menus dees-windowcontrols {
        align-self: stretch;
        flex: 0 0 auto;
      }

      .menuItem {
        position: relative;
        min-height: 26px;
        line-height: 1;
        padding: 0 10px;
        margin: 0;
        border: 1px solid transparent;
        border-radius: var(--dees-radius-md);
        -webkit-app-region: no-drag;
        transition:
          background var(--dees-transition-fast) var(--dees-ease-standard),
          border-color var(--dees-transition-fast) var(--dees-ease-standard),
          color var(--dees-transition-fast) var(--dees-ease-standard),
          box-shadow var(--dees-transition-fast) var(--dees-ease-standard);
        cursor: default;
        outline: none;
        display: flex;
        align-items: center;
        gap: 6px;
        color: var(--appbar-fg);
        font-weight: 500;
        white-space: nowrap;
      }

      /* Optional: Style for menu items with icons (not typically used for top-level items) */
      .menuItem dees-icon {
        font-size: 13px;
        opacity: 0.8;
      }

      .menuItem:hover {
        background: var(--dees-color-hover);
        color: var(--appbar-fg-strong);
      }

      .menuItem.active {
        background: var(--appbar-wash-strong);
        border-color: var(--appbar-control-border);
        box-shadow: inset 0 1px 0 color-mix(in srgb, var(--dees-color-bg-primary) 22%, transparent);
        color: var(--appbar-fg-strong);
      }

      /* A checked choice in the bar itself. The hovered face repeats the rule at
         a higher specificity so the state survives under the pointer. */
      .menuItem.checked {
        background: color-mix(in srgb, var(--dees-color-accent-primary) 12%, transparent);
        color: var(--appbar-fg-strong);
      }

      .menuItem.checked:hover {
        background: color-mix(in srgb, var(--dees-color-accent-primary) 20%, transparent);
        color: var(--appbar-fg-strong);
      }

      .menuItem[disabled] {
        opacity: 0.5;
        cursor: not-allowed;
        pointer-events: none;
      }

      .menuItem:focus-visible {
        box-shadow: 0 0 0 2px var(--dees-color-focus-ring);
      }

      /* Divider entries in the menu bar; submenus open through the context menu overlay. */
      .dropdown-divider {
        height: 1px;
        background: var(--dees-color-border-subtle);
        margin: 4px 0;
      }

      /* Breadcrumbs */
      .breadcrumbs {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        min-width: 0;
        height: 100%;
        padding: 0 16px 0 8px;
        overflow: hidden;
        color: var(--appbar-fg-faint);
        white-space: nowrap;
      }

      .breadcrumb-item {
        display: inline-block;
        min-width: 0;
        max-width: 180px;
        overflow: hidden;
        text-overflow: ellipsis;
        color: var(--appbar-fg);
        cursor: default;
        transition: color var(--dees-transition-fast) var(--dees-ease-standard);
      }

      .breadcrumbs.with-location { overflow: visible; justify-content: center; padding-inline: 12px; }

      .breadcrumb-item:hover {
        color: var(--appbar-fg-strong);
      }

      .breadcrumb-item:last-child {
        color: var(--appbar-fg-strong);
        font-weight: 600;
      }

      .breadcrumb-separator {
        margin: 0 6px;
        color: var(--appbar-fg-faint);
      }

      /* Account section */
      .account {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        min-width: max-content;
        height: 100%;
        padding: 0 10px 0 8px;
        gap: 6px;
        overflow: hidden;
      }

      .search-icon {
        width: 28px;
        height: 28px;
        display: grid;
        place-items: center;
        border-radius: var(--dees-radius-full);
        cursor: default;
        color: var(--appbar-fg);
        font-size: 15px;
        transition:
          background var(--dees-transition-fast) var(--dees-ease-standard),
          color var(--dees-transition-fast) var(--dees-ease-standard);
      }

      .search-icon:hover {
        background: var(--dees-color-hover);
        color: var(--appbar-fg-strong);
      }

      .user-info {
        display: flex;
        align-items: center;
        gap: 7px;
        height: 28px;
        cursor: default;
        padding: 0 9px 0 4px;
        border: 1px solid transparent;
        border-radius: var(--dees-radius-full);
        color: var(--appbar-fg);
        font-weight: 500;
        transition:
          background var(--dees-transition-fast) var(--dees-ease-standard),
          border-color var(--dees-transition-fast) var(--dees-ease-standard),
          color var(--dees-transition-fast) var(--dees-ease-standard);
      }

      .user-info:hover {
        background: var(--dees-color-hover);
        color: var(--appbar-fg-strong);
      }

      .user-avatar {
        position: relative;
        width: 22px;
        height: 22px;
        border-radius: 50%;
        background: var(--appbar-wash-strong);
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 10px;
        font-weight: 600;
        color: var(--appbar-fg-strong);
        box-shadow: inset 0 0 0 1px var(--dees-color-border-subtle);
      }

      .user-avatar img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
        object-fit: cover;
      }

      .user-status {
        position: absolute;
        bottom: -2px;
        right: -2px;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        border: 2px solid var(--dees-appui-chrome-bg);
      }

      .user-status.online {
        background: var(--dees-color-accent-success);
      }

      .user-status.offline {
        background: var(--dees-color-text-muted);
      }

      .user-status.busy {
        background: var(--dees-color-accent-error);
      }

      .user-status.away {
        background: var(--dees-color-accent-warning);
      }

      /* Activity log toggle button */
      .activity-toggle {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 4px;
        height: 28px;
        min-width: 28px;
        padding: 0 8px;
        border-radius: var(--dees-radius-full);
        cursor: default;
        -webkit-app-region: no-drag;
        color: var(--appbar-fg);
        border: 1px solid transparent;
        transition:
          background var(--dees-transition-fast) var(--dees-ease-standard),
          border-color var(--dees-transition-fast) var(--dees-ease-standard),
          color var(--dees-transition-fast) var(--dees-ease-standard);
      }

      .activity-toggle:hover {
        background: var(--dees-color-hover);
        color: var(--appbar-fg-strong);
      }

      .activity-toggle.active {
        background: var(--appbar-wash-strong);
        color: var(--appbar-fg-strong);
        border-color: var(--appbar-control-border);
      }

      .activity-toggle dees-icon {
        font-size: 14px;
      }

      .activity-badge {
        position: relative;
        margin-left: 4px;
        min-width: 16px;
        height: 16px;
        padding: 0 4px;
        background: var(--dees-color-badge-default-bg);
        color: var(--dees-color-badge-default-fg);
        font-size: 10px;
        font-weight: 600;
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        line-height: 1;
      }

      @media (prefers-reduced-motion: reduce) {
        .menuItem,
        .breadcrumb-item,
        .search-icon,
        .user-info,
        .activity-toggle {
          transition: none;
        }
      }

      .account { grid-column: 3; }

      @container (max-width: 720px) {

        .menus:has(.compact-menus) .full-menus { display: none; }
        .compact-menus { display: flex; }

        .breadcrumbs {
          display: none;
        }

        dees-appui-location[editing] { position: absolute; left: 8px; right: 8px; top: 50%; transform: translateY(-50%); width: auto; max-width: none; z-index: 1; }
        .breadcrumbs.with-location { display: flex; padding-inline: 4px; }

        .menuItem {
          padding: 0 8px;
        }

        .account {
          padding-inline: 4px 6px;
        }

        .user-info span {
          display: none;
        }
      }
      @container (max-width: 450px) { .compact-menus .menuItem { font-size: 0; gap: 0; } .compact-menus dees-icon { font-size: 16px; } }
    `,
  ];
